import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import Select from "react-select";
import { toast } from "react-toastify";

const AddworkShiftModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
	Service,
}) => {
	const [formData, setFormData] = useState({
		name: "",
		clockIn: "",
		clockOut: "",
		lateAllowanceMinutes: "",
		spansNextDay: false,
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			Service.find(item?.id).then((res) => {
				if (res?.status) {
					const response = res?.data?.data;
					setIsAdd(false);
					setFormData({
						id: item?.id,
						name: response?.name,
						clockIn: response?.clockIn,
						clockOut: response?.clockOut,
					});
				}
			});
		}
	}, [item]);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			name: formData?.name,
			clockIn: `${formData?.clockIn}:00`,
			clockOut: `${formData?.clockOut}:00`,
			lateAllowanceMinutes: formData?.lateAllowanceMinutes,
			spansNextDay: formData?.spansNextDay,
		};

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(`WorkShift Added Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(formData?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(`WorkShift Updated Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade" : "ar fade"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#000",
										fontSize: "22px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.work_shift}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Name */}
						<Col md={12}>
							<AvField
								label={Translate[lang]?.name}
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({ ...formData, name: e.target.value })
								}
							/>
						</Col>
						{/* Clock In*/}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.clockIn}
								type="time"
								placeholder={Translate[lang]?.clockIn}
								bsSize="lg"
								name="clockIn"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.clockIn}
								onChange={(e) =>
									setFormData({ ...formData, clockIn: e.target.value })
								}
							/>
						</Col>
						{/* Clock Out*/}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.clockOut}
								type="time"
								placeholder={Translate[lang]?.clockOut}
								bsSize="lg"
								name="clockOut"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.clockOut}
								onChange={(e) =>
									setFormData({ ...formData, clockOut: e.target.value })
								}
							/>
						</Col>
						{/* Late Allowance Minutes */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.late_allowance_minutes}
								type="number"
								placeholder={Translate[lang]?.min}
								bsSize="lg"
								name="lateAllowanceMinutes"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.lateAllowanceMinutes}
								onChange={(e) =>
									setFormData({
										...formData,
										lateAllowanceMinutes: e.target.value,
									})
								}
							/>
						</Col>
						{/* Spans Next Day*/}
						<Col md={6}>
							<div className="">
								<label className="d-block mb-3" htmlFor="custom-switch">
									{Translate[lang].spans_next_day}
								</label>
								<Form.Check
									type="switch"
									id="custom-switch"
									checked={formData?.spansNextDay}
									onChange={(e) =>
										setFormData({ ...formData, spansNextDay: e.target.checked })
									}
								/>
							</div>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.work_shift}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddworkShiftModal;
